import React from 'react';
import { makeField } from 'nike-form-js';
import FieldErrors from './FieldErrors';
import { useReframe } from 'nike-re-framejs';

export function forcedValidation(form) {
    return form.getIn(['forcedValidation']);
}

const PathError = ({ form, path }) => {
    const { deref } = useReframe();
    const field = makeField(form, path);
    const errors = deref(field.getErrors());
    const isForcedValidation = deref(form.map(forcedValidation));
    const isError = isForcedValidation && errors.size > 0;
    return isError ? <FieldErrors errors={errors} /> : null;
};

export default PathError;
